import subDepartmentsCommitTypes from "./commit-types";

const INITIAL_SUB_DEPARTMENTS_STATE = {
  list: [],
  isLoading: []
};

function subDepartmentsReducers(state = INITIAL_SUB_DEPARTMENTS_STATE, action) {
  if (!action || !action.type) {
    return state;
  }

  switch (action.type) {
    case subDepartmentsCommitTypes.PUSH_SUB_DEPARTMENTS:
      return {
        ...state,
        list: action.subDepartments
      };
    case subDepartmentsCommitTypes.PUSH_SUB_DEPARTMENT:
      return {
        ...state,
        list: [...state.list, action.subDepartment]
      };
    default:
      return state;
  }
}

export default subDepartmentsReducers;